import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import PsatPoster from '../../assets/images/popup/psat-2026-poster.jpg';

const FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSde-HFwUaiXALrJXaIfY9P3MykaEfxDEQn3cmHTpSHwQZaIjg/viewform';

const PsatPopup = () => {
  const [open, setOpen] = useState(true);
  const [zoomed, setZoomed] = useState(false);
  const location = useLocation();

  // Reopen when navigated here from the scholarship pin
  useEffect(() => {
    if (location.state?.showPsat) setOpen(true);
  }, [location.key, location.state]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[92vw] max-w-md p-2 gap-2 bg-white [&>button]:bg-white [&>button]:p-1 [&>button]:opacity-100 [&>button]:shadow">
        <DialogTitle className="sr-only">PSAT 2026 - Prayas Scholarship Aptitude Test</DialogTitle>
        <button type="button" onClick={() => setZoomed(true)} className="block w-full cursor-zoom-in">
          <img
            src={PsatPoster}
            alt="PSAT 2026 - Prayas Scholarship Aptitude Test"
            className="w-full max-h-[75vh] object-contain rounded"
          />
        </button>
        <p className="text-center text-xs text-gray-500 -mt-1">Tap the poster to view it full size</p>

        <Dialog open={zoomed} onOpenChange={setZoomed}>
          <DialogContent className="w-[96vw] max-w-3xl p-0 bg-white [&>button]:bg-white [&>button]:p-1.5 [&>button]:opacity-100 [&>button]:shadow">
            <DialogTitle className="sr-only">PSAT 2026 Poster</DialogTitle>
            <div className="max-h-[95vh] overflow-y-auto">
              <img
                src={PsatPoster}
                alt="PSAT 2026 - Prayas Scholarship Aptitude Test"
                className="w-full h-auto"
              />
            </div>
          </DialogContent>
        </Dialog>
        <a
          href={FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center bg-red-800 hover:bg-red-900 text-white font-semibold py-2.5 rounded transition-colors"
        >
          Register Now
        </a>
      </DialogContent>
    </Dialog>
  );
};

export default PsatPopup;
